import React from 'react';

import './index.scss';

const BubbleNotification = ({ message, showNotification, id }) => {
  return (
    <div className="notification">
      {(showNotification && showNotification=== id )?
      (<div className="notification__bubble">
        <p dangerouslySetInnerHTML={{__html: message.replace(/(<? *script)/gi, 'illegalscript')}}></p>
      </div>):
      (null)}
    </div>
  );
};

export default BubbleNotification;
